<template>
  <div class="ma-0 pa-0">
    <v-row justify="end" class="pr-10">
      <span>탑승 인원 {{passengerCount}}</span>
    </v-row>
    <v-list>
      <template
          v-for="(item, index) in reservationRouteList"
      >
        <v-list-item
            :key="index"
        >
          <v-row align="center">
            <v-col cols="3">{{ getPositionName(index, reservationRouteList.length) }}</v-col>
            <v-col cols="6">{{ item.position }}</v-col>
            <v-col cols="3">
              <passenger-count
                  :count.sync="passengerDataList[index].onCnt"
                  :count2.sync="passengerDataList[index].offCnt"
                  :initial-count="item.onCnt"
                  :initial-count2="item.offCnt"
                  :is-flex-column="true"
                  :disable-on-btn="item.seq === 1"
                  :disable-off-btn="item.seq === 0"
              />
            </v-col>
          </v-row>
        </v-list-item>
        <v-divider
            :key="index"
        />
      </template>
    </v-list>
  </div>
</template>

<script>

import PassengerCount from "./Common/PassengerCount";
export default {
  name: 'PassengerUpdateForm',
  components: {PassengerCount},
  props: {
    passengerCount: {
      type: Number
    },
    reservationRouteList: {
      type: Array
    }
  },
  data() {
    return {
      passengerDataList: this.reservationRouteList ? this.reservationRouteList.map((item) => ({seq: item.seq, onCnt: 0, offCnt: 0})) : []
    }
  },
  watch: {
    passengerDataList: {
      deep: true,
      handler() {
        this.$emit('update:passengerDataList', this.passengerDataList);
      }
    }
  },
  methods: {
    getPositionName(index, length) {
      if (index === 0) {
        return '출발지'
      } else if ( index === length - 1 ) {
        return '도착지'
      } else {
        return `경유지${index}`
      }
    },
  },
}

</script>